export const ZIPCODE_VALIDATION_REGEX = {
  // Canada: matches "M5G", "M5G3S2", "M5G-3S2" or "M5G 3S2". Must be uppercase
  CA: /(^[ABCEGHJKLMNPRSTVXY]\d[ABCEGHJ-NPRSTV-Z]$)|(^[ABCEGHJKLMNPRSTVXY]\d[ABCEGHJ-NPRSTV-Z][\s|-]?\d[ABCEGHJ-NPRSTV-Z]\d)/,
  // US: matches "33131" or "33131-4782".
  US: /(^\d{5}$)|(^\d{5}-\d{4}$)/,
}